var render, staticRenderFns
import script from "./myTable.vue?vue&type=script&lang=js"
export * from "./myTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f841f230",
  null
  
)

export default component.exports